import request from "@/utils/request";

export function postIdServerExternalAuthenticate(data, headers) {
    return request({
        headers: { "X-Requested-With": "XMLHttpRequest" },
        url: "/api/TokenAuth/IdServerExternalAuthenticate",
        method: "POST",
        headers, 
        data
    });
}

export function externalAuthenticate(data) {
    return request({
        url: "/api/TokenAuth/ExternalAuthenticate",
        method: "POST",
        data
    });
}



// WEBPACK FOOTER //
// ./src/api/token_auth.js